import React from 'react'

const SvgMonitorOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.791 17a1 1 0 00-.94.658l-.363 1A1 1 0 007.427 20h9.146a1 1 0 00.94-1.342l-.365-1a1 1 0 00-.94-.658H14v-3h5a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v8a1 1 0 001 1h5v3H7.791zM6 12V6h12v6H6z'
    />
  </svg>
)

export default SvgMonitorOutline
